//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StarLevel from './StarLevel/StarLevel';

export default {
  name: 'hotel-item',
  components: {
    StarLevel,
  },
  props: {
    data: Object,
    startTime: String,
    endTime: String,
  },
  computed: {
    lanType(){
      return +window.localStorage.getItem('lan_type');
    },
  },
  methods: {
    onToHotelDetail(event, hotelId){
      let param = {
        hotel_id: hotelId,
        start_date: this.startTime,
        end_date: this.endTime,
      };

      this.$router.push({name: 'hotel-detail', params: param});
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/HotelItem.vue